// #NOTE: [EM] 
// hidden: the state of the object is false in all chapters
// #TODO: clipped: the object is fully clipped by every active clipping plane in all chapters - requires relatively expensive query
// #TODO: transparent: the object is fully transparent in every chapter - not yet implemented
// #TODO: disabled: the object id disabled (not able to be shown even by tweens) - not yet implemented

interface GraphTrimModel {
  hidden: boolean;
  disabled: boolean;
  clipped: boolean;
  transparent: boolean;
}

// configuration for trimming objects out of the scene graph on serialization
export class TrimConfiguration {
    graph: GraphTrimModel;

    constructor() {
      this.graph = {
        hidden: false,
        clipped: false,
        disabled: false,
        transparent: false
      };
    }
}
